import React, { useEffect, useState } from 'react';
import {
  Layout, Table,
} from 'antd';
import isEqual from 'lodash.isequal';
import { useFormik, FormikProvider, Form } from 'formik';
import { useHistory } from 'react-router-dom';
import { useActions } from '../../../providers/actions-provider/actions.context';
// import { useStore } from '../../../../store';
import '../data-model.less';
import useErd from './use-erd';
import PageTitle from '../../../lib/page-title';
import PrimaryButton from '../../../lib/primary-button';
import FormControl from '../../../lib/form-control';
import PermissionProvider from '../../../providers/permissionProvider';
import checkPermission from '../../../../utils/permissions/permissions';
import SecondaryButton from '../../../lib/secondary-button/secondary-button';
import { DATA_MODEL_DIAGRAM_PATH, DATA_MODEL_EDIT_PATH } from '../../../routing/paths.constants';

const ErdEdit = (): JSX.Element => {
  const {
    // columns,
    onCreateProperty,
  } = useErd();
  const { tenantActions } = useActions();
  const [newSchemaFormVisible, setNewSchemaFormVisible] = useState(false);
  const [tree, setTree] = useState([]);
  const { push } = useHistory();

  // const {
  //   tenantProperties,
  // } = useStore();
  const initialValues = {
    model: '',
  };
  const formik = useFormik({
    initialValues,
    onSubmit: (values) => {
      onCreateProperty(values.model);
      setNewSchemaFormVisible(false);
    },
    enableReinitialize: true,
  });

  useEffect(() => {
    tenantActions.getModelTree()
      .then((data) => setTree(data));
  }, []);
  const {
    values,
  } = formik;
  const formHasChanged = !isEqual(initialValues, values);
  const columns = [{
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  }, {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    width: 250,
    // eslint-disable-next-line
    render: (_: string, record: any) => (
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        {
          !record.parents && (
            <SecondaryButton
              type="button"
              className="button-edit ant-btn--small"
              onClick={() => {
                push(`${DATA_MODEL_DIAGRAM_PATH}/${record.name}`);
              }}
            >
              View Diagram
            </SecondaryButton>
          )
        }
        <SecondaryButton
          type="button"
          className="button-execute ant-btn--small"
          onClick={() => {
            push(`${DATA_MODEL_EDIT_PATH}/${record.name}`);
          }}
        >
          {record.permissions === 'ro' ? 'View' : 'Edit'}
        </SecondaryButton>
      </div>
    ),
  }];

  return (
    <Layout className="main-container">
      <PermissionProvider pageId="datamodel">
        <PageTitle title="Data Model">
          {(!newSchemaFormVisible && checkPermission('datamodel', 'write')) ? (
            <PrimaryButton
              title="New Entity"
              onClick={() => {
                setNewSchemaFormVisible(true);
              }}
            />
          ) : ''}
        </PageTitle>
        {newSchemaFormVisible && (
          <div className="new-model-wrapper">
            <FormikProvider value={formik}>
              <Form className="formik-form">
                <FormControl
                  inputClassName="user-form__input"
                  name="model"
                  label="Add New Model"
                  type="text"
                />
                <PrimaryButton type="submit" className="ant-btn ant-btn-primary formik-form__submit" disabled={!formHasChanged || !checkPermission('datamodel', 'write')}>
                  Save
                </PrimaryButton>
              </Form>
            </FormikProvider>
          </div>
        )}
        {tree.length > 0 ? (
          <Table
            key="model-tree"
            columns={columns}
            dataSource={tree}
            pagination={false}
            rowKey="id"
            expandable={{
              defaultExpandAllRows: true,
            }}
          />
        ) : null}
      </PermissionProvider>
    </Layout>
  );
};

export default ErdEdit;
